<template>
  <first-page>
    <sign-in-form/>
  </first-page>
</template>

<script>
import FirstPage from "@/components/pages/FirstPage";
import SignInForm from "@/components/login/SignInForm";

export default {
  name: "SignInPage",
  components: {SignInForm, FirstPage}
}
</script>

<style scoped>

</style>
